// Responsive branded wrapper (spec 08 §3): logo, orange accent bar, DM Sans with Arial fallback, 600 px.
import { escapeHtml, isHttpsUrl } from "./render.ts";
import type { Lang } from "./types.ts";

const FONT = "'DM Sans',Arial,Helvetica,sans-serif";

/**
 * GAVION 2026-10-30 (owner: « bon espacement entre les lignes »): explicit block spacing on the template body, so
 * Outlook clients that zero paragraph margins still show one blank line between paragraphs. Only bare tags (the
 * sanitised template body has no attributes on them); the rep's signature is not passed through it.
 */
export function spaceBlocks(html: string): string {
  return html
    .replace(/<p>/g, '<p style="margin:0 0 16px 0;">')
    .replace(/<ul>/g, '<ul style="margin:0 0 16px 0;padding-left:24px;">')
    .replace(/<ol>/g, '<ol style="margin:0 0 16px 0;padding-left:24px;">')
    .replace(/<li>/g, '<li style="margin:0 0 6px 0;">');
}

export function wrapInLayout(i: {
  bodyHtml: string;
  preheader: string;
  footerHtml: string | null;
  lang: Lang;
  logoUrl: string;
}): string {
  if (!isHttpsUrl(i.logoUrl)) throw new Error("logo_url_unsafe");
  const pre = i.preheader
    ? `<div style="display:none;max-height:0;overflow:hidden;opacity:0;">${escapeHtml(i.preheader)}</div>`
    : "";
  const footer = i.footerHtml
    ? `<tr><td class="gv-pad" style="padding:16px 32px 24px 32px;border-top:1px solid #EEEEEE;font-family:${FONT};font-size:12px;line-height:1.5;color:#6B6B6B;">${i.footerHtml}</td></tr>`
    : "";
  return `<!doctype html>
<html lang="${i.lang}"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><meta name="x-apple-disable-message-reformatting"><title></title>
<style>@media (max-width:620px){.gv-container{width:100% !important}.gv-pad{padding-left:20px !important;padding-right:20px !important}}</style></head>
<body style="margin:0;padding:0;background:#FAFAF9;">${pre}
<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#FAFAF9;"><tr><td align="center" style="padding:24px 12px;">
<table role="presentation" class="gv-container" width="600" cellpadding="0" cellspacing="0" style="width:600px;max-width:600px;background:#FFFFFF;border-radius:12px;overflow:hidden;">
<tr><td style="height:4px;background:#F77119;font-size:0;line-height:0;">&nbsp;</td></tr>
<tr><td class="gv-pad" style="padding:24px 32px 8px 32px;"><img src="${escapeHtml(i.logoUrl)}" alt="Gavion" width="120" style="display:block;border:0;height:auto;"></td></tr>
<tr><td class="gv-pad" style="padding:8px 32px 24px 32px;font-family:${FONT};font-size:16px;line-height:1.5;color:#1A1A1A;">${i.bodyHtml}</td></tr>
${footer}
</table></td></tr></table></body></html>`;
}
